/* eslint-disable radix */
import React, { Component } from 'react';
import ConfiguracoesCertificadoPage from './certificado.page';
import ConfiguracaoApi from '../../configuracao.api';
import * as commonActions from '../../../../app/common/common.action';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

class ConfiguracoesCertificadoContainer extends Component {
  constructor() {
    super();
    this.state = {
      urlCartorio: '',
      modoEnvio: {value: 0, label: 'Sincrono'},
      versaoCartorio: '',
      habilitar: false,
      hsm: false,
    };
 
  }

  tiposEnvios = [
    {value: 0, label: 'Sincrono'},
    {value: 1, label: 'Assincrono'}
  ];

  getDefault() {}
  salvar(e) {
    e.preventDefault();
    const payload = {
      certificacao_Api_Url: this.state.urlCartorio,
      certificacao_Tipo_Envio: this.state.modoEnvio.value,
      certificacao_Versao_Cartorio: this.state.versaoCartorio,
      certificacao_Habilitar: this.state.habilitar, 
      certificacao_Hsm: this.state.hsm, 
    };
    this.props.commonActions.showFadeCarregando(true);
    ConfiguracaoApi.gravarConfigCertificacaoDigital(payload).then(() => {
      let mensagem = 'Configurações de Certificação Digital salva com sucesso';
      this.props.commonActions.showAlerta(
        'sucesso',
        mensagem,
        2000,
        mensagem.length * 10 + 'px'
      );
      this.props.commonActions.showFadeCarregando(false);
    });
  }
  changeUrl(val) {
    this.setState({urlCartorio: val});
  }
  changeTipoEnvio(val) {
    this.setState({modoEnvio: val});
  }
  changeVersaoCartorio(val) {
    this.setState({versaoCartorio: val});
  }
  changeHabilitar(val) {
    this.setState({habilitar: val});
  }
  changeHSM(val) {
    this.setState({hsm: val});
  }

  render() {


    return (

      <ConfiguracoesCertificadoPage
        tiposEnvios={this.tiposEnvios}
        urlCartorio={this.state.urlCartorio}
        modoEnvio={this.state.modoEnvio}
        versaoCartorio={this.state.versaoCartorio}
        habilitar={this.state.habilitar}
        hsm={this.state.hsm}
        salvar={this.salvar.bind(this)}
        changeUrl={this.changeUrl.bind(this)}
        changeTipoEnvio={this.changeTipoEnvio.bind(this)}
        changeVersaoCartorio={this.changeVersaoCartorio.bind(this)}
        changeHabilitar={this.changeHabilitar.bind(this)}
        changeHSM={this.changeHSM.bind(this)}
      />
    );
  }

  componentDidMount() {
    this.props.commonActions.showFadeCarregando(true);
    ConfiguracaoApi.getConfigCertificacaoDigital()
      .then((res) => {
        this.setState({
          urlCartorio: res.certificacao_Api_Url,
          versaoCartorio: res.certificacao_Versao_Cartorio,
          modoEnvio: this.tiposEnvios.filter(x => x.value === res.certificacao_Tipo_Envio),
          habilitar: res.certificacao_Habilitar,
          hsm: res.certificacao_Hsm,
        });
        this.props.commonActions.showFadeCarregando(false);
      })
      .catch(() => {
        this.props.commonActions.showFadeCarregando(false);
      });
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    commonActions: bindActionCreators(commonActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfiguracoesCertificadoContainer);



// WEBPACK FOOTER //
// ./src/pages/configuracao/tab/certificado/certificado.container.js